<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-6">
    <!-- <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
    {{'AUTOMATION.CREATE.HEADER' | translate }} <i class="fa fa-circle-question text-xl text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
  </h1> -->
    <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
        {{ 'AUTOMATION.CREATE.HEADER' | translate }} - {{automationData.name}}
        <i class="fa fa-pencil text-600 text-lg cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"
        (click)="OpenCustomAutomationPopup()"></i>
    </h1>

    <div class="border-none surface-100 p-1 md:pl-0 text-xs">
        <app-breadcrumb></app-breadcrumb>
    </div>

    <!-- Cards -->
    <div class="grid text-sm mt-2">
        <!-- Card -->
        <div class="col-12 md:col-7">
            <div class="surface-0 border-round shadow-1 border-1 border-300 p-3 flex flex-column justify-content-between h-full">
                <!-- Block -->
                <div class="mb-4">
                    <div class="flex align-items-center mb-2">
                        <h6 class="font-medium text-700 text-xs block mb-0 uppercase">{{ 'AUTOMATION.CREATE.DESCRIPTION' | translate }}</h6>
                        <i class="fa fa-pencil text-600 cursor-pointer ml-2" (click)="OpenCustomAutomationPopup()"></i>
                    </div>
                    <p *ngIf="!showSkeleton" class="mb-0">{{automationData.description}}</p>
                    <p-skeleton *ngIf="showSkeleton" width="100%" height="1.35rem"></p-skeleton>
                </div>
                <!-- Block -->

                <!-- Block -->
                <div>
                    <div class="flex align-items-center mb-2">
                        <h6 class="font-medium text-700 text-xs block mb-0 uppercase">{{ 'AUTOMATION.CREATE.AUTOMATION_FOR' | translate }}</h6>
                        <i class="fa fa-pencil text-600 cursor-pointer ml-2" [ngClass]="automationData.event === 'update' ? 'opacity-40 pointer-events-none': ''" (click)="OpenCustomAutomationPopup()"></i>
                    </div>
                    <p class="mb-0" *ngIf="!showSkeleton && automationData?.ownershiplevel  === ownerShipLevel.Franchise || automationData?.ownershiplevel?.toString()  === ownerShipLevel[ownerShipLevel.Franchise]">
                        <strong>{{ 'AUTOMATION.CREATE.FRANCHISE' | translate }} :</strong>
                        {{ 'AUTOMATION.CREATE.FRENCHISE_TENANT_LBL'| translate :{ count : automationData.selectedFrenchiseTenants.length, name:automationData.selectedFrenchise?.franchise_group_primary_name} }}
                    </p>
                    <p class="mb-0" *ngIf="!showSkeleton && automationData?.ownershiplevel  === ownerShipLevel.Company || automationData?.ownershiplevel?.toString()  === ownerShipLevel[ownerShipLevel.Company]">
                        <strong>{{ 'AUTOMATION.CREATE.COMPANY'| translate }} :</strong>
                        {{ 'AUTOMATION.CREATE.FRENCHISE_TENANT_LBL' | translate :{ count : automationData.selectedCompanyTenants.length, name : companyDetails.value ? companyDetails.value.name_primary_language : ""} }}
                    </p>
                    <p class="mb-0" *ngIf="!showSkeleton && automationData?.ownershiplevel  === ownerShipLevel.Tenant || automationData?.ownershiplevel?.toString()  === ownerShipLevel[ownerShipLevel.Tenant]">
                        <strong>{{ 'AUTOMATION.CREATE.CURRENT_TENANT'| translate }} :</strong>
                        {{ loggedInTenant.name_primary_language }}
                    </p>
                    <p-skeleton *ngIf="showSkeleton" width="15rem" height="1.35rem"></p-skeleton>

                </div>
                <!-- Block -->
            </div>
        </div>
        <!-- Card -->

        <!-- Card -->
        <div class="col-12 md:col-5">
            <div class="surface-0 border-round shadow-1 border-1 border-300 flex flex-column justify-content-between h-full">
                <!-- Block -->
                <div class="p-3">
                    <div class="flex align-items-center mb-2">
                        <h6 class="font-medium text-700 text-xs block mb-0 uppercase">{{ 'AUTOMATION.CREATE.TRIGGER' | translate }}</h6>
                        <i class="fa fa-pencil text-600 cursor-pointer ml-2" [ngClass]="automationData.event === 'update' ? 'opacity-40 pointer-events-none': ''" (click)="OpenEventPopup()"></i>
                    </div>
                    <h4 class="text-sm md:text-lg mb-0" *ngIf="!showSkeleton && automationData.automationType">{{ 'AUTOMATION.EVENT.'+automationData.automationType | translate }}</h4>
                    <p-skeleton *ngIf="showSkeleton" width="15rem" height="1.35rem"></p-skeleton>
                </div>
                <!-- Block -->

                <!-- Block -->
                <div (click)="OpenQueryBuilderPopup()" class="surface-100 text-primary cursor-pointer p-3 flex align-items-center">
                    <i class="fa fa-filter mr-2"></i>
                    <strong>{{ 'AUTOMATION.CREATE.COND_FILTER_OUT' | translate}}</strong>
                </div>
                <!-- Block -->
            </div>
        </div>
        <!-- Card -->

        <!-- Card -->
        <div class="col-12" *ngIf="automationData?.notificationSelected">
            <div class="surface-0 border-round shadow-1 border-1 border-300 p-3 flex flex-column justify-content-between h-full">
                <!-- Block -->
                <div class="flex align-items-center mb-2">
                    <h6 class="font-medium text-700 text-xs block mb-0 uppercase">{{ 'AUTOMATION.CREATE.STAFF_NOTIF_SETT' | translate }}</h6>
                    <i (click)="OpenStaffNotificationPopup()" class="fa fa-pencil text-600 cursor-pointer ml-2"></i>
                </div>
                <strong *ngIf="!showSkeleton && automationData.associatedStaff && automationData.additionalStaffTo.length > 0">{{ 'AUTOMATION.CREATE.ASSO_STAFF_AND_OTHR' | translate }} ({{ automationData.additionalStaffTo.length }}) </strong>
                <strong *ngIf="!showSkeleton && automationData.associatedStaff && automationData.additionalStaffTo.length === 0">{{ 'AUTOMATION.CREATE.ASSO_STAFF' | translate }}</strong>
                <p-skeleton *ngIf="showSkeleton" width="15rem" height="1.35rem"></p-skeleton>
                <!-- Block -->
            </div>
        </div>
        <!-- Card -->
    </div>
    <!-- Cards -->

    <!-- Card -->
    <div class="surface-0 shadow-2 border-round text-sm mt-2">
        <!-- Header -->
        <div class="flex flex-wrap align-items-center justify-content-between p-3">
            <h5 class="text-sm mb-0">{{'AUTOMATION.CREATE.COMM_SCHEDULE' | translate }}</h5>
            <div class="p-buttonset">
                <button
                    [ngClass]="showListView ? 'bg-primary' : 'surface-600' "
                    (click)="showListView=true"
                    (click)="showGridView=false"
                    pButton
                    pRipple
                    icon="fa fa-list"
                    class="surface-600 h-2rem w-2rem border-none border-left-2 border-white"
                ></button>
                <button [ngClass]="showGridView ? 'bg-primary' : 'surface-600' " (click)="showGridView=true" (click)="showListView=false" pButton pRipple icon="fa-regular fa-calendar-days" class="h-2rem w-2rem border-none"></button>
            </div>
            <div class="flex align-items-center justify-content-between lg:justify-content-end mt-3 lg:mt-0 w-full lg:w-auto">
                <div class="mr-2">
                    
                    <p-button icon="fa fa-angle-dow" [label]="'AUTOMATION.CREATE.BTN_ADD_CLIENT' | translate" iconPos="right" styleClass="text-xs px-2 md:text-sm md:px-3" (click)="addClientActions.toggle($event)">
                        <i class="fa fa-user-group mr-2 hidden md:inline-block"></i>
                    </p-button>
                    <!-- <p-button icon="fa fa-angle-down" [label]="'AUTOMATION.CREATE.BTN_ADD_CLIENT' | translate" iconPos="right" styleClass="text-sm md:hidden" (click)="addClientActions.toggle($event)"></p-button> -->
                    <p-popover #addClientActions styleClass="overflow-hidden right-0 text-sm w-12rem">
                        <ng-template #content>
                            <ul class="list-none -m-2 p-0 text-sm font-bold">
                                <li class="cursor-pointer" *ngFor="let action of ClientActions;let i = index" (click)="configureActions(action.key, action.notificationTo,null,'create')" [ngClass]="{'mt-2': i !== 0}">
                                    {{ 'CAMPAIGN.TABLE.'+action.text | translate }}
                                </li>
                            </ul>
                        </ng-template>
                    </p-popover>
                </div>
                <div class="mr-2">
                    <p-button icon="fa fa-angle-down" [label]="'AUTOMATION.CREATE.BTN_ADD_STAFF' | translate" iconPos="right" styleClass="p-button-outlined text-xs px-2 md:text-sm md:px-3" (click)="addStaffActions.toggle($event)">
                        <i class="fa fa-user-tie mr-2 hidden md:inline-block"></i>
                    </p-button>
                    <!-- <p-button icon="fa fa-angle-down" [label]="'AUTOMATION.CREATE.BTN_ADD_STAFF' | translate" iconPos="right" styleClass="p-button-outlined text-sm md:hidden" (click)="addStaffActions.toggle($event)"></p-button> -->
                    <p-popover #addStaffActions styleClass="overflow-hidden right-0 text-sm w-12rem">
                        <ng-template #content>
                            <ul class="list-none -m-2 p-0 text-sm font-bold">
                                <li class="cursor-pointer" *ngFor="let action of StaffActions;let i = index" (click)="configureActions(action.key, action.notificationTo,null,'create')" [ngClass]="{'mt-2': i !== 0}">
                                    {{ 'CAMPAIGN.TABLE.'+action.text | translate }}
                                </li>
                            </ul>
                        </ng-template>
                    </p-popover>
                </div>
                <p-button
                    [label]="'AUTOMATION.CREATE.BTN_CLEAR' | translate"
                    icon="fa fa-trash-alt"
                    styleClass="text-sm p-button-outlined p-button-secondary font-bold border-300 hidden md:inline-block"
                    (onClick)="clearAllActions()"
                    [loading]="clearbtnLoading"
                ></p-button>
                <p-button icon="fa fa-trash-alt" styleClass="h-2rem w-2rem p-button-outlined p-button-secondary font-bold border-300 md:hidden"></p-button>
            </div>
        </div>
        <!-- Header -->

        <!-- Content -->
        <div>
            <!-- Grid View -->
            <div *ngIf="showGridView">
                <div class="-mt-3">
                    <p-message severity="info" icon="fa fa-info-circle" aria-label="calendar-message">
                        {{'AUTOMATION.CREATE.CAL_MSG' | translate }}
                    </p-message>
                </div>
                <ejs-schedule #scheduleObj
                    [eventSettings]="eventSettings"
                    [selectedDate]="calenderDefaultdata"
                    [currentView]="currentView"
                    [rowAutoHeight]="true"
                    class="block mx-auto"
                    (eventClick)="onEventClick($event)"
                    (eventRendered)="onEventRendered($event)"
                >
                    <e-views>
                        <e-view option="Month" showWeekend="true">
                        <ng-template #eventTemplate let-data>
                            <div class="my-title">{{data.subject}}</div>
                            <div *ngIf="findIndexByObjectProperty(calendarEvent, data, 'id') === 0">
                                <i class="fa-solid fa-star text-primary fa-3x"></i>
                            </div>
                        </ng-template>
                    </e-view>
                    </e-views>
                </ejs-schedule>
            </div>
            <!-- Grid View -->

            <!-- List View -->
            <div *ngIf="showListView">
                <!-- Table -->
                <div class="overflow-hidden" *ngIf="ActionTableData.length > 0">
                    <p-table [value]="ActionTableData" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="text-xs text-600 border-none p-0"></th>
                                <th class="text-xs text-600 border-none p-0"></th>
                                <th class="text-xs text-600 border-none p-0"></th>
                                <th class="text-xs text-600 border-none p-0"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-tableData>
                            <tr class="text-sm">
                                <td class="py-3 white-space-nowrap relative border-left-3 border-{{tableData.color}} border-top-none px-0">
                                    &nbsp; &nbsp;
                                    <strong>{{tableData.schedule_event}}</strong>
                                    <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0 absolute left-0 top-0 w-full" />
                                </td>
                                <td class="py-3 white-space-nowrap">
                                    <div class="flex align-items-center text-{{tableData.color}} px-3">
                                        <strong *ngIf="tableData.notificationTo === notificationTo.Client" class="mr-3 bg-blue-50 text-primary border-1 border-primary border-round px-2 py-1">Client</strong>
                                        <strong *ngIf="tableData.notificationTo === notificationTo.Staff" class="mr-3 surface-50 text-600 border-1 border-300 border-round px-2 py-1">Staff</strong>
                                        <i class="{{tableData.icon}} mr-2"></i>
                                        <strong>{{ 'CAMPAIGN.TABLE.'+tableData.text | translate }}</strong>
                                    </div>
                                </td>
                                <td *ngIf="tableData.key !== 'createtask'" class="py-3 white-space-nowrap" [innerHTML]="tableData.description ?? tableData.description.length > 40 ? tableData.description.slice(0, 40) + '...' : tableData.description"></td>
                                <td *ngIf="tableData.key === 'createtask'" class="py-3 white-space-nowrap" [innerHTML]="tableData.description ?? ''"></td>
                                <td class="py-3 text-right">
                                    <p-button
                                        icon="fa fa-angle-down"
                                        [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
                                        iconPos="right"
                                        styleClass="surface-0 p-button-outlined border-300 text-600 text-sm"
                                        (click)="showActions.toggle($event)"
                                    ></p-button>
                                    <p-popover #showActions styleClass="overflow-hidden right-0 text-sm w-9rem">
                                        <ng-template #content>
                                            <ul *ngIf="tableData.status !== 'Attended'" class="list-none -m-4 px-0 py-2 text-xs text-600">
                                                <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" (click)="configureActions(tableData.key,tableData.notificationTo,tableData,'update')">
                                                    <i class="fa fa-pencil text-500 mr-2"></i>{{'common.BUTTONS.BUTTON_TEXT_EDIT' | translate}}
                                                </li>
                                                <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" (click)="deleteData(tableData.key, tableData.uuid)">
                                                    <i class="fa fa-trash-alt text-500 mr-2"></i>{{'common.BUTTONS.BTN_DELETE' | translate}}
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </p-popover>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <!-- Table -->
                <div class="text-center py-5" *ngIf="ActionTableData.length === 0">
                    <p class="mb-4">{{ 'AUTOMATION.CREATE.ADD_COMM' | translate }}</p>
                    <img src="assets/img/empty-state-automation-img.svg" alt="Image" />
                  </div>
            </div>
            <!-- List View -->
        </div>
        <!-- Content -->
    </div>
    <!-- Card -->

     <!-- Buttons -->
     <div class="flex align-items-center justify-content-between mt-3 pt-2">
        <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" (onClick)="CancelAutomation()" styleClass="p-button-text text-sm"></p-button>
        <p-button [label]="(automationGuid !== '' ? 'CAMPAIGN.BTN_UPDATE' : 'CAMPAIGN.BTN_SAVE') | translate" [disabled]="!createAutomationForm.valid" [loading]="btnLoading" (click)="CreateAutomation()" styleClass="text-sm"></p-button>
    </div>
    <!-- Buttons -->
</div>
<!-- Body Content-->

<!-- Child Components -->

<create-opportunity *ngIf="showCreateOpportunityPopup" [visible]="showCreateOpportunityPopup" (hidePopup)="hideOpportunity($event)"></create-opportunity>

<send-bulk-email
    *ngIf="showBulkEmailPopup"
    [visible]="showBulkEmailPopup"
    [tenantId]="tenantId"
    [franchiseId]="automationData.selectedFrenchise ? automationData.selectedFrenchise.franchise_group_id : 0"
    [EmailSendType]="EmailSendType"
    [CampaignSource]="campaignSource"
    [actionPayload]="getEmailActipnPayload"
    [automationMaster]="getSelectedAutomationType"
    [formGroup]="formGroup"
    (hide)="HideEmailPopup($event)"
    [uuid]="uuid"
    [mode]="mode"
    [scheduleInMin]="scheduleInMin"
    [notificationTo]="selectedNotificationTo"
    [ownership]="automationData.ownershiplevel"
>
</send-bulk-email>

<send-bulk-sms
    *ngIf="showBulkSmsPopup"
    [visible]="showBulkSmsPopup"
    [tenantId]="tenantId"
    [franchiseId]="automationData.selectedFrenchise ? automationData.selectedFrenchise.franchise_group_id : 0"
    [SMSSendType]="SMSSendType"
    [CampaignSource]="campaignSource"
    [actionPayload]="getSmsActipnPayload"
    (hide)="HideSMSPopup($event)"
    [automationMaster]="getSelectedAutomationType"
    [formGroup]="formGroup"
    [uuid]="uuid"
    [mode]="mode"
    [scheduleInMin]="scheduleInMin"
    [notificationTo]="selectedNotificationTo"
    [ownership]="automationData.ownershiplevel"
>
</send-bulk-sms>

<send-whatsapp
    *ngIf="showBulkWhatsAppPopup"
    [visible]="showBulkWhatsAppPopup"
    [tenantId]="tenantId"
    [franchiseId]="automationData.selectedFrenchise ? automationData.selectedFrenchise.franchise_group_id : 0"
    [WhatsAppSendType]="WhatsAppSendType"
    [CampaignSource]="campaignSource"
    [actionPayload]="getWhatsappActipnPayload"
    (hide)="HideWhatsAppPopup($event)"
    [automationMaster]="getSelectedAutomationType"
    [formGroup]="formGroup"
    [uuid]="uuid"
    [mode]="mode"
    [scheduleInMin]="scheduleInMin"
    [notificationTo]="selectedNotificationTo"
    [ownership]="automationData.ownershiplevel"
>
</send-whatsapp>

<task-create
    *ngIf="showTaskCreate"
    [visible]="showTaskCreate"
    [TaskCreateType]="taskCreateType"
    [CampaignSource]="campaignSource"
    [actionPayload]="getTaskActipnPayload"
    [automationMaster]="getSelectedAutomationType"
    [formGroup]="formGroup"
    [uuid]="uuid"
    [mode]="mode"
    [scheduleInMin]="scheduleInMin"
    (hide)="hideTaskCreate($event)"
    [notificationTo]="selectedNotificationTo"
>
</task-create>

<staff-notification-setting-popup *ngIf="showStaffNotificationSettings" [firstTimeSelected]="firstTimeSelected"
[visible]="showStaffNotificationSettings" [Data]="automationData" (hide)="HideStaffNotificationPopup($event)">
</staff-notification-setting-popup>



<!-- Child Components -->
